import { createPortal } from 'react-dom';
import { useNotification } from '../hooks';
import { NotificationPositions } from './molecules/NotificationPositions';

/**
 * Componente que renderiza todas las notificaciones en un portal
 * @example
 * <Notifier />
 */
export const Notifier = () => {
  const { groups } = useNotification();
  return createPortal(<NotificationPositions groups={groups} />, document.body);
};
